module.exports = __webpack_public_path__ + "static/media/TUNE_6510.26d2a7d1.jpg";